//
//  src/components/sliders/SliderStudio.js
//
import AwesomeSlider from 'react-awesome-slider';
import withAutoplay  from 'react-awesome-slider/dist/autoplay';
import React, { useRef, useState, useEffect } from "react";
import 'react-awesome-slider/dist/styles.css';
import './SliderStudio.css';


//
//  studio[s] — loaded dynamically from the folder
//
const studioImages = require.context(
    '../../images/studio',
    false,
    /\.(webp|jpe?g|png)$/i
);
const studioSrcs = studioImages.keys().sort().map((key) => studioImages(key));


//
//  slider studio
//
const AutoplaySlider = withAutoplay(AwesomeSlider);

/** IO rootMargin only allows px or % — 25% of viewport height inset top & bottom (center band). */
function centerBandRootMarginPx() {
    const inset = Math.round(window.innerHeight * 0.25);
    return `-${inset}px 0px -${inset}px 0px`;
}

export default function SliderStudio() {
    const wrapperRef = useRef(null);
    /** True while the slider overlaps the vertical center band of the viewport */
    const [inCenterBand, setInCenterBand] = useState(false);

    useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return undefined;

        let observer;

        const connect = () => {
            if (observer) observer.disconnect();
            observer = new IntersectionObserver(
                ([entry]) => {
                    setInCenterBand(entry.isIntersecting);
                },
                {
                    root: null,
                    rootMargin: centerBandRootMarginPx(),
                    threshold: 0.15,
                }
            );
            observer.observe(el);
        };

        connect();
        window.addEventListener("resize", connect);
        return () => {
            window.removeEventListener("resize", connect);
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);

    return (
        <div ref={wrapperRef} className={`slider-studio-wrapper${inCenterBand ? " in-view" : ""}`}>
            <AutoplaySlider
                bullets={ false }
                organicArrows={ false }
                play={ true }
                interval={ 12000 }
                fillParent
            >
                {studioSrcs.map((src, i) => (
                    <div
                        key={i}
                        data-src={src}
                        data-alt={`Studio space ${i + 1}`}
                    />
                ))}
            </AutoplaySlider>
        </div>
    );
}
